import React, { useState, useEffect } from "react";
import axios from 'axios'
import base64 from 'base-64'

import { GlobalContext, HOST } from "./GlobalContext";

const LOGIN_USER = HOST + '/api/inv/login/'
const ESTADOS_API = HOST + '/api/inv/estado/'
const PROVEEDORES_API = HOST + '/api/inv/proveedor/'
const CLIENTES_API = HOST + '/api/inv/cliente/'
const LIBROSPROV_API = HOST + '/api/inv/libros/'
const COMPRAS_API = HOST + '/api/inv/ordenCompra/'
const PARTIDAS_API = HOST + '/api/inv/ordenDetalle/'
const REMISION_API = HOST + '/api/inv/remision/'
const REMISION_PARTIDAS_API = HOST + '/api/inv/remisionDetalle/'
const VENCIMIENTOS_API = HOST + '/api/inv/vencimientos/'
const VENCIDOS_API = HOST + '/api/inv/vencidos/'
const EDITORAS_API = HOST + '/api/inv/editora/'
const ALMACEN_API = HOST + '/api/inv/almacen/'
const VENTAS_API = HOST + '/api/inv/ventas/'
const PREFACTURAS_API = HOST + '/api/inv/prefacturas/'
const REPORT_API = HOST + '/api/inv/report/'

export default function ContextWrapper(props) {
  const [ logged, setLogged ] = useState(false)
  const [ userName, setUserName ] = useState('')
  const [ name, setName ] = useState('')
  const [ rol, setRol ] = useState(0)
  const [ token, setToken ] = useState('')

  const [ btnDisabled, setBtnDisabled ] = useState(false)
  const [ searchText, setSearchText ] = useState('Ingresar')
  const [ isActive, setIsActive ] = useState(false)
  const [ showWrongCredentials, setShowWrongCredentials ] = useState(false)
  const [ addressList, setAddressList ] = useState([])
  const [ addressOptions, setAddressOptions ] = useState([])
  const [ globalLoading, setGlobalLoading ] = useState( false )

  const [ showMesage, setShowMesage ] = useState( false )
  const [ mailBody, setMailBody ] = useState('')
  const [ mailTitle, setMailTitle ] = useState('')

  const [ visitor, setVisitor ] = useState(null)
  const [ toVisitor, setToVisitor ] = useState( false )
  const [ callback, setCallback ] = useState()

  const [ estadosList, setEstadosList ] = useState([])
  const [ proveedoresList, setProveedoresList ] = useState([])
  const [ librosList, setLibrosList ] = useState([])
  const [ librosProvList, setLibrosProvList ] = useState([])
  const [ comprasList, setComprasList ] = useState([])
  const [ partidasList, setPartidasList ] = useState([])
  const [ remisionesList, setRemisionesList ] = useState([])
  const [ remisionPartidasList, setRemisionPartidasList ] = useState([])
  const [ editorasList, setEditorasList ] = useState([])
  const [ almacenList, setAlmacenList ] = useState([])
  const [ vencimientosList, setVencimientosList ] = useState([])
  const [ vencidosList, setVencidosList ] = useState([])
  const [ clientesList, setClientesList ] = useState([])
  const [ ventasList, setVentasList ] = useState([])
  const [ prefacturasList, setPrefacturasList ] = useState([])
  const [ reportList, setReportList ] = useState([])

  const [ initState, ] = useState({ estados: false, proveedores: false })

  useEffect(() => {
    console.log("logged context", logged)
    if(logged) {
      setGlobalLoading(true)
      getEstados()
      getProveedores()
      getEditoras()
      getAlmacenes()
      setSession()
    }
  }, [logged]);

  useEffect(() => {
    console.log("status", initState.estados, initState.proveedores)
    if( initState.estados && initState.proveedores )
      setGlobalLoading(false)
  }, [ initState ]);

  const setSession = () => {
    setUserName( sessionStorage.getItem('lji_auth') )
    setName( sessionStorage.getItem('lji_name') )
    setRol( parseInt(sessionStorage.getItem('lji_rol')) )
    setToken( sessionStorage.getItem('lji_token') )
  }

  const logOut = () => {
    sessionStorage.removeItem('lji_auth')
    sessionStorage.removeItem('lji_name')
    sessionStorage.removeItem('lji_rol')
    sessionStorage.removeItem('lji_visitor')
    sessionStorage.removeItem('lji_token')

    window.location.reload()
  }

  const getLogin = (usrName, password) => {
    setSearchText('Enviando...')
    setBtnDisabled( true )

    var userPass = 'Basic ' + encode64(usrName + ":" + password);
    console.log("setting login", userPass)

    axios.post(LOGIN_USER, {}, {
      headers: {
        'Authentication': userPass
      }
    }).then(result => {
      const json = result.data
      console.log("json result", json)
  
      if( json.idUsuario != null ) {
        sessionStorage.setItem('lji_auth', json.idUsuario)
        sessionStorage.setItem('lji_name', json.nombre)
        sessionStorage.setItem('lji_rol', json.idPerfil)
        sessionStorage.setItem('lji_token', json.token)

        setUserName( json.idUsuario )
        setName( json.nombre )
        setRol( parseInt(json.idPerfil) )
        setToken( json.token )
  
        setIsActive(false)
        setSearchText("Iniciar sesión")
        setBtnDisabled( false )//lo puse yo
        setLogged( true )
      } else {
        setIsActive(false)
        setShowWrongCredentials(true)
        setSearchText("Iniciar sesión")
        setBtnDisabled( false )//lo puse yo
  
        setMailTitle("Error")
        setMailBody('El usuario o contraseña son incorrectos. Favor de verificar los datos y volver a intentarlo.')
      }
      
    })
    .catch(error => {
      setIsActive(false)
      setShowWrongCredentials(true)
      setSearchText("Iniciar sesión")
  
      setMailTitle("Error")
      setMailBody('Ocurrio un error al intentar accesar. Favor de intentarlo más tarde.')
      setBtnDisabled( false )//lopuse yo
    })
  }

  const getEstados = () => {
    axios({
      method: 'get',
      url: ESTADOS_API,
    })
    .then(result => {
      setEstadosList(result.data)
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const getEditoras = () => {
    axios({
      method: 'get',
      url: EDITORAS_API,
    })
    .then(result => {
      console.log("editoras", result.data)
      setEditorasList( result.data )
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const getProveedores = () => {
    axios({
      method: 'get',
      url: PROVEEDORES_API,
    })
    .then(result => {
      setProveedoresList( result.data )
      setGlobalLoading(false)
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const getClientes = () => {
    axios({
      method: 'get',
      url: CLIENTES_API,
    })
    .then(result => {
      setClientesList( result.data )
      setGlobalLoading(false)
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const getAlmacenes = () => {
    axios({
      method: 'get',
      url: ALMACEN_API,
    })
    .then(result => {
      console.log("almacenes", result.data)
      setAlmacenList( result.data )
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const getLibros = () => {
    axios({
      method: 'get',
      url: LIBROSPROV_API,
      headers: { 'Authentication': token }
    })
    .then(result => {
      setLibrosList( result.data )
      setGlobalLoading(false)
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const getLibrosProv = (idProveedor) => {
    axios({
      method: 'get',
      url: LIBROSPROV_API + idProveedor,
    })
    .then(result => {
      setLibrosProvList( result.data )
      setGlobalLoading(false)
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const getOrdenesCompra = () => {
    axios({
      method: 'get',
      url: COMPRAS_API,
    })
    .then(result => {
      setComprasList( result.data )
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const getRemisiones = () => {
    axios({
      method: 'get',
      url: REMISION_API,
    })
    .then(result => {
      setRemisionesList( result.data )
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const getPartidas = ( id ) => {
    axios({
      method: 'get',
      url: PARTIDAS_API + id,
    })
    .then(result => {
      let data = result.data

      data.sort((a, b) => {
        const aValue = JSON.stringify(Object.values(a).sort());
        const bValue = JSON.stringify(Object.values(b).sort());

        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
      });

      //console.log("partidas", data)
      setPartidasList(data)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const getPartidasRemision = ( id ) => {
    axios({
      method: 'get',
      url: REMISION_PARTIDAS_API + id,
      headers: { 'Authentication': token }
    })
    .then(result => {
      //console.log("remision partidas", result.data)
      let data = result.data

      if( data.lenght > 0 ) {
        data.sort((a, b) => {
          const aValue = JSON.stringify(Object.values(a).sort());
          const bValue = JSON.stringify(Object.values(b).sort());

          if (aValue < bValue) return -1;
          if (aValue > bValue) return 1;
          return 0;
        });
      }

      setRemisionPartidasList(data)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const getVencimientos = ( key ) => {
    axios({
      method: 'get',
      url: VENCIMIENTOS_API + key,
      headers: { 'Authentication': token }
    })
    .then(result => {
      //console.log("remision partidas", result.data)
      let data = result.data

      setVencimientosList(data)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const getVencidos = () => {
    setVencidosList([])

    axios({
      method: 'get',
      url: VENCIDOS_API,
      headers: { 'Authentication': token }
    })
    .then(result => {
      //console.log("remision partidas", result.data)
      let data = result.data

      setVencidosList(data)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const getVentas = ( dateInit, dateEnd, saleDestitny, paymentType ) => {
    axios({
      method: 'get',
      url: VENTAS_API + '?init=' + dateInit+ '&end=' + dateEnd + '&df=' + saleDestitny + '&tp=' + paymentType,
      headers: { 'Authentication': token }
    })
    .then(result => {
      setVentasList( result.data )
      setGlobalLoading(false)
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const getPrefacturas = ( dateInitP, dateEndP ) => {
    axios({
      method: 'get',
      url: PREFACTURAS_API + '?init=' + dateInitP + '&end=' + dateEndP,
      headers: { 'Authentication': token }
    })
    .then(result => {
      setPrefacturasList( result.data )
      setGlobalLoading(false)
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const getReport = ( dateInitP, dateEndP, idProveedor ) => {
    axios({
      method: 'get',
      url: REPORT_API + '?init=' + dateInitP + '&end=' + dateEndP + "&idProveedor=" + idProveedor,
      headers: { 'Authentication': token }
    })
    .then(result => {
      setReportList( result.data )
      setGlobalLoading(false)
    })
    .catch(error => {
      console.log("error", error.message)
    })
  }

  const backHome = () => {
    sessionStorage.removeItem('pls_visitor')
    setVisitor( null )
    setToVisitor( false )
  }

  const encode64 = (input) => {
    return base64.encode(input);
  };

  const formDataToJson = (formData) => {
    var object = {};
    formData.forEach(function(value, key){
        object[key] = value;
    });
    var json = JSON.stringify(object);

    return json;
  }

  const dateForm = ( date ) => {
    var applyDate = new Date( date );
    applyDate.setTime(applyDate.getTime() + applyDate.getTimezoneOffset() * 60 * 1000);
    
    return applyDate.getTime()
  }

  const getNombreEstado = (idEstado) => {
    return estadosList.find(o => o.idEstado === parseInt(idEstado));
  }

  const getNombreEditorial = (idEditora) => {
    return editorasList.find(o => o.idEditora === parseInt(idEditora));
  }

  const getNombreProveedor = (idProveedor) => {
    return proveedoresList.find(o => o.idProveedor === parseInt(idProveedor));
  }

  const getNombreLibro = (idLibro) => {
    return librosList.find(o => o.idLibro === parseInt(idLibro));
  }

  const getISBN = (isbn) => {
    console.log("libros", librosList, 'codigo isbn', isbn)
    return librosList.find(o => o.codigoIsbn === isbn);
  }

  const getNombreLibroProv = (idLibro) => {
    return librosProvList.find(o => o.idLibro === parseInt(idLibro));
  }

  const getNombreAlmacen = (idAlmacen) => {
    return almacenList.find(o => o.idAlmacen === parseInt(idAlmacen));
  }

  const getNombreCliente = (idCliente) => {
    return clientesList.find(o => o.idCliente === parseInt(idCliente));
  }

  const getNombreOrden = (idOrden) => {
    return comprasList.find(o => o.idOrden === parseInt(idOrden));
  }

  return (
    <GlobalContext.Provider
      value={{
        logged, setLogged,
        userName, setUserName,
        name, setName,
        rol, setRol,
        token, setToken,
        btnDisabled, setBtnDisabled,
        searchText, setSearchText,
        isActive, setIsActive,
        mailBody, setMailBody,
        mailTitle, setMailTitle,
        showMesage, setShowMesage,
        showWrongCredentials, setShowWrongCredentials,
        visitor, setVisitor,
        addressList, setAddressList,
        addressOptions, setAddressOptions,
        toVisitor, setToVisitor,
        globalLoading, setGlobalLoading,
        callback, setCallback,
        estadosList, setEstadosList,
        proveedoresList, setProveedoresList,
        librosProvList, setLibrosProvList,
        partidasList, setPartidasList,
        comprasList, setComprasList,
        remisionesList, setRemisionesList,
        remisionPartidasList, setRemisionPartidasList,
        librosList, setLibrosList,
        editorasList, setEditorasList,
        almacenList, setAlmacenList,
        vencimientosList, setVencimientosList,
        vencidosList, setVencidosList,
        clientesList, setClientesList,
        ventasList, setVentasList,
        prefacturasList, setPrefacturasList,
        reportList, setReportList,
        getLogin,
        logOut,
        backHome,
        formDataToJson,
        dateForm,
        getNombreProveedor,
        getNombreLibro,
        getLibrosProv,
        getOrdenesCompra,
        getPartidas,
        getRemisiones,
        getPartidasRemision,
        getLibros,
        getEditoras,
        getProveedores,
        getNombreEditorial,
        getAlmacenes,
        getNombreAlmacen,
        getNombreEstado,
        getNombreLibroProv,
        getVencimientos,
        getISBN,
        getVencidos,
        getClientes,
        getVentas,
        getNombreCliente,
        getPrefacturas,
        getNombreOrden,
        getReport
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
}
